import { Controller } from "stimulus";
import { debounce } from 'lodash';

export default class extends Controller {
  static targets = ['searchTerm', 'form']

  initialize() {
    this.search = debounce(this.search, 1000).bind(this)
  }

  search(event) {
    let term = event.target.value;

    if(term && term != '') {
      $("#spinner").removeClass('hidden');
      $(".search-icon").addClass('hidden');
      Rails.fire(this.formTarget, 'submit');
    } else {
      $('#search-results').empty().addClass('hidden');
      $("#spinner").addClass('hidden');
      $(".search-icon").removeClass('hidden');
    }
  }

  searchAll(event) {
    let type = event.target.dataset.model;
    let companyId = event.target.dataset.companyId;

    let url = '';
    let params = { global_search: true };

    if (type == 'learners') {
      params['q'] = { full_name_or_phone_or_internal_id_or_first_name_or_last_name_or_email_cont: this.searchTermTarget.value }
      url = `/companies/${companyId}/learners?${jQuery.param(params)}`
    } else if (type == 'trainings') {
      params['q'] = { title_cont: this.searchTermTarget.value }
      url = `/companies/${companyId}/trainings?${jQuery.param(params)}`
    } else if (type == 'classrooms') {
      url = `/companies/${companyId}/classrooms`
    } else if (type == 'kiosk') {
      url = `/companies/${companyId}/kiosk_links`
    } else if (type == 'locations') {
      url = `/companies/${companyId}/locations`
    }

    if (url == '') {
      return;
    }

    window.location.href = url;
  }
}
